/* eslint-disable no-nested-ternary */
import { Body1 } from '@flatsy/core/MaterialUi/Typo'
import i18n from '@flatsy/utils/translations'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import clsx from 'clsx'
import React from 'react'
import { LogoAgency } from 'src/utils/LogoAgency'
import useStyles from './Style'
import { componentProps } from './Type'

const TopBar: React.FC<componentProps> = ({
  asset,
  open,
  handleOpen,
  withRadius,
}): React.ReactElement => {
  const classes = useStyles()

  return (
    <button
      type="button"
      className={clsx(classes.topBar, withRadius && classes.topBarRadius)}
      onClick={handleOpen}
    >
      <div className={classes.logoWrapper}>{LogoAgency(classes, asset?.logo_url)}</div>
      <div className={classes.topBarContent}>
        {!open && <Body1>{i18n.t('tour_information')}</Body1>}
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </div>
    </button>
  )
}

export default TopBar
